import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({className}: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
  <path d="M6.66667 6.66667L0 0H13.3333L6.66667 6.66667Z" fill="#333333"/>
</svg>
);

export default Icon;
